/* FRØYA GOURMET — froya-kort.js v3.2 (31.10.2026). Produktcelle-karusell: mus = hover-innfading, touch = auto (aktiv celle) + sveip.
   v3.2 (FART + STABILITET):
     • FORVARMING: bildelistene (product .js) og første bytte-bilde hentes og dekodes i stillhet før musa kommer (kun mus-enheter, kun celler nær skjermen,
       én av gangen i ledige øyeblikk). Før ble alt hentet først når man holdt musa over — derfor ble første hover seig, og «å gå videre og tilbake»
       virket (da lå alt i hurtigbufferen).
     • FEIL HUSKES IKKE: en mislykket henting (treg side, nettverkshikk) ble før bufret som tom liste for resten av økten → cellen spilte aldri mer. Nå prøves den på nytt.
     • SCROLL: myk scroll sender scroll-hendelser i ca. ett sekund etter at hjulet stopper, og hver av dem stoppet karusellen. Hvis musa sto stille over en celle
       startet den aldri igjen før musa ble beveget. Nå sjekkes cellen under musa på nytt like etter at scrollingen har roet seg.
     • Hover-venting 350 → 250 ms.
   v3.1: hover-venting 1100 → 350 ms (rettene vises raskere), hold 2300 → 2000 ms. */
(function () {
  'use strict';
  if (window.__fgKort) return;
  window.__fgKort = true;

  var mqMus = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');
  var mqRo = window.matchMedia('(prefers-reduced-motion: reduce)');

  var VENT = 250;
  var HOLD = 2000;
  var BREDDE = 900;
  var MAKS = 3;

  var T_VENT = 1500;
  var T_HOLD = 2800;
  var T_BREDDE = 640;
  var T_RUNDER = 2;
  var T_TOPP = 64;

  var MEDIA = '.fg-card__media, .fgc__media, .resource-card__media, product-card .card-gallery';
  var CELLE = '.fg-card, .fgc__card, .resource-card, product-card';
  var LENKE = 'a.fg-card__link, a.fgc__link, a.resource-card__link, a.product-card__link, a[href*=products]';

  var cache = {};
  var a = null;
  var sist = 0;
  var idleT = 0;
  var tp = null;
  var tomme = [];
  var ferdige = [];
  var holdt = [];
  var musX = -1;
  var musY = -1;
  var roT = 0;

  function touchModus() { return !mqMus.matches && !mqRo.matches; }
  function sparer() { var c = navigator.connection; return !!(c && c.saveData); }
  function har(liste, el) { return liste.indexOf(el) > -1; }
  function bruk(el) { return !!el && !el.querySelector('slideshow-component'); }

  function url(u, w) {
    u = String(u || '');
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function hent(href) {
    var u = href.split('#')[0].split('?')[0];
    if (cache[u]) return cache[u];
    cache[u] = fetch(u + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.images) { delete cache[u]; return []; }
        return p.images;
      })
      .catch(function () { delete cache[u]; return []; });
    return cache[u];
  }

  function forbered(list) {
    return Promise.all(list.map(function (src) {
      return new Promise(function (res) {
        var im = new Image();
        im.onload = im.onerror = function () { res(im); };
        im.src = src;
        holdt.push(im);
        if (holdt.length > 80) holdt.shift();
        if (im.decode) im.decode().then(function () { res(im); }, function () { res(im); });
      });
    }));
  }

  /* --- Forvarming (kun mus): hent bildeliste + første bytte-bilde før hover --- */
  var varmKo = [];
  var varmSett = [];
  var varmGar = false;

  function ledig(fn) {
    if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 1500 });
    else setTimeout(fn, 200);
  }

  function varm(media) {
    if (!mqMus.matches || mqRo.matches || sparer()) return;
    if (varmSett.length > 60 || har(varmSett, media) || !bruk(media)) return;
    varmSett.push(media);
    varmKo.push(media);
    if (!varmGar) { varmGar = true; ledig(neste); }
  }

  function neste() {
    var m = varmKo.shift();
    if (!m) { varmGar = false; return; }
    var l = document.body.contains(m) ? lenkeFra(m) : null;
    if (!l) { ledig(neste); return; }
    hent(l.getAttribute('href') || l.href).then(function (alle) {
      if (alle && alle.length > 1) return forbered([url(alle[1], BREDDE)]);
    }).then(function () {
      setTimeout(function () { ledig(neste); }, 120);
    }, function () { ledig(neste); });
  }

  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); varm(e.target); }
    });
  }, { rootMargin: '300px 0px 300px 0px' }) : null;

  function skann() {
    if (!io || !mqMus.matches) return;
    var els = document.querySelectorAll(MEDIA);
    for (var k = 0; k < els.length; k++) {
      if (!els[k].__fgObs) { els[k].__fgObs = true; io.observe(els[k]); }
    }
  }

  function lag(src, touch) {
    var im = document.createElement('img');
    im.className = 'fg-card__layer fg-ok' + (touch ? ' fg-card__layer--t' : '');
    im.alt = '';
    im.setAttribute('aria-hidden', 'true');
    im.draggable = false;
    im.decoding = 'async';
    im.src = src;
    return im;
  }

  function vis(s) {
    var im = lag(s.liste[s.i], s.kind === 'touch');
    s.media.appendChild(im);
    void im.offsetWidth;
    im.classList.add('is-pa');
    var under = s.lag.slice();
    s.lag.push(im);
    setTimeout(function () {
      under.forEach(function (x) {
        if (x.parentNode) x.parentNode.removeChild(x);
        var k = s.lag.indexOf(x);
        if (k > -1) s.lag.splice(k, 1);
      });
    }, 1100);
  }

  function skjulLag(s) {
    var rest = s.lag.slice();
    s.lag = [];
    rest.forEach(function (x) { x.classList.remove('is-pa'); x.classList.add('is-av'); });
    setTimeout(function () {
      rest.forEach(function (x) { if (x.parentNode) x.parentNode.removeChild(x); });
    }, 1100);
  }

  function levende(s) {
    if (document.body.contains(s.media)) return true;
    stopp(s);
    return false;
  }

  function steg(s) {
    if (s.dead || !levende(s)) return;
    if (s.liste.length === 1 && s.lag.length) return;
    s.i = (s.i + 1) % s.liste.length;
    vis(s);
    s.t = setTimeout(function () { steg(s); }, HOLD);
  }

  function lagPrikker(s) {
    var d = document.createElement('span');
    d.className = 'fg-card__dots';
    d.setAttribute('aria-hidden', 'true');
    for (var k = 0; k <= s.liste.length; k++) d.appendChild(document.createElement('span'));
    s.media.appendChild(d);
    s.dots = d;
    markPrikk(s, s.p);
    requestAnimationFrame(function () { d.classList.add('is-vis'); });
  }

  function markPrikk(s, n) {
    if (!s.dots) return;
    var c = s.dots.children;
    for (var k = 0; k < c.length; k++) c[k].classList.toggle('is-on', k === n);
  }

  function posTil(s, p) {
    var n = s.liste.length + 1;
    p = ((p % n) + n) % n;
    if (p === s.p) return;
    s.p = p;
    if (p === 0) {
      skjulLag(s);
    } else {
      s.i = p - 1;
      vis(s);
    }
    markPrikk(s, p);
  }

  function tsteg(s) {
    if (s.dead || s.manual || s.paused || !levende(s)) return;
    posTil(s, s.p + 1);
    s.antall++;
    if (s.antall >= T_RUNDER * (s.liste.length + 1)) {
      s.t = setTimeout(function () {
        if (s.dead) return;
        ferdige.push(s.media);
        stopp(s);
        vurder();
      }, T_HOLD);
      return;
    }
    s.t = setTimeout(function () { tsteg(s); }, T_HOLD);
  }

  function pause(s) {
    s.paused = true;
    clearTimeout(s.v);
    clearTimeout(s.t);
  }

  function gjenoppta(s) {
    s.paused = false;
    if (s.manual) return;
    clearTimeout(s.v);
    s.v = setTimeout(function () {
      s.ventet = true;
      if (s.klar && !s.dead) tsteg(s);
    }, 900);
  }

  function mediaVed(x, y) {
    var els = document.querySelectorAll(MEDIA);
    for (var k = 0; k < els.length; k++) {
      var r = els[k].getBoundingClientRect();
      if (r.width > 0 && bruk(els[k]) && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return els[k];
    }
    return null;
  }

  function vurder() {
    if (!touchModus() || document.hidden) return;
    var H = window.innerHeight;
    var best = null;
    var bestD = 1e9;
    var els = document.querySelectorAll(MEDIA);
    var igjen = [];
    for (var k = 0; k < els.length; k++) {
      var el = els[k];
      var r = el.getBoundingClientRect();
      if (r.height < 40 || !bruk(el)) continue;
      var synlig = (Math.min(r.bottom, H) - Math.max(r.top, T_TOPP)) / r.height;
      if (har(ferdige, el)) {
        if (synlig > 0.2) igjen.push(el);
        continue;
      }
      if (synlig < 0.6 || har(tomme, el)) continue;
      var d = Math.abs((r.top + r.bottom) / 2 - (H + T_TOPP) / 2);
      if (d < bestD) { bestD = d; best = el; }
    }
    ferdige = igjen;

    if (sparer()) return;

    if (a && a.kind === 'touch') {
      if (best && a.media === best) {
        if (a.paused) gjenoppta(a);
        return;
      }
      if (a.manual) {
        var rr = a.media.getBoundingClientRect();
        if (rr.bottom > T_TOPP + 30 && rr.top < H - 30) { if (a.paused) a.paused = false; return; }
      }
      stopp(a);
    } else if (a) {
      stopp(a);
    }
    if (best) start(best, 'touch');
  }

  function sveip(m, dir) {
    if (a && a.kind === 'touch' && a.media === m && !a.dead) { sveipPa(a, dir); return; }
    if (a) stopp(a);
    var s = start(m, 'touch');
    if (!s) return;
    sveipPa(s, dir);
  }

  function sveipPa(s, dir) {
    s.manual = true;
    clearTimeout(s.v);
    clearTimeout(s.t);
    if (s.klar) posTil(s, s.p + dir);
    else s.onKlar = function () { posTil(s, s.p + dir); };
  }

  function inRect(e, el) {
    var r = el.getBoundingClientRect();
    return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
  }

  function mediaFra(e) {
    var t = e.target;
    if (!(t instanceof Element)) return null;
    var m = t.closest(MEDIA);
    if (m) return m;
    var rc = t.closest('.resource-card');
    if (rc) {
      var rm = rc.querySelector('.resource-card__media');
      return rm && inRect(e, rm) ? rm : null;
    }
    var c = t.closest('product-card');
    if (!c) return null;
    var g = c.querySelector('.card-gallery');
    return g && inRect(e, g) ? g : null;
  }

  function lenkeFra(media) {
    var c = media.closest(CELLE);
    return c ? c.querySelector(LENKE) : null;
  }

  function start(media, kind) {
    var lenke = lenkeFra(media);
    var touch = kind === 'touch';
    if (!lenke) { if (touch) tomme.push(media); return null; }
    var s = {
      media: media, kind: kind, liste: null, lag: [], i: -1, p: 0, antall: 0,
      dead: false, t: 0, v: 0, klar: false, ventet: false, manual: false, paused: false,
      dots: null, onKlar: null, bredde: touch ? T_BREDDE : BREDDE
    };
    a = s;
    hent(lenke.getAttribute('href') || lenke.href).then(function (alle) {
      if (s.dead) return;
      var list = alle.slice(1, 1 + MAKS).map(function (x) { return url(x, s.bredde); });
      if (!list.length) {
        if (touch) tomme.push(media);
        if (a === s) a = null;
        s.dead = true;
        clearTimeout(s.v);
        if (touch) setTimeout(vurder, 0);
        return;
      }
      return forbered(list.slice(0, 1)).then(function () {
        if (s.dead) return;
        s.liste = list;
        s.klar = true;
        if (list.length > 1) forbered(list.slice(1));
        if (touch) lagPrikker(s);
        if (s.onKlar) { var f = s.onKlar; s.onKlar = null; f(); return; }
        if (s.ventet && !s.manual && !s.paused) { if (touch) tsteg(s); else steg(s); }
      });
    });
    s.v = setTimeout(function () {
      s.ventet = true;
      if (!s.klar || s.manual || s.paused) return;
      if (touch) tsteg(s); else steg(s);
    }, touch ? T_VENT : VENT);
    return s;
  }

  function stopp(s) {
    if (!s) return;
    s.dead = true;
    clearTimeout(s.v);
    clearTimeout(s.t);
    var rest = s.lag.slice();
    rest.forEach(function (x) { x.classList.remove('is-pa'); x.classList.add('is-av'); });
    setTimeout(function () {
      rest.forEach(function (x) { if (x.parentNode) x.parentNode.removeChild(x); });
    }, 1100);
    if (s.dots) {
      var d = s.dots;
      s.dots = null;
      d.classList.remove('is-vis');
      setTimeout(function () { if (d.parentNode) d.parentNode.removeChild(d); }, 500);
    }
    if (a === s) a = null;
  }

  function pek(e) {
    if (!mqMus.matches || mqRo.matches) {
      if (a && a.kind === 'mus') stopp(a);
      return;
    }
    if (a && a.kind === 'touch') stopp(a);
    var m = mediaFra(e);
    if (a) {
      if (m === a.media) return;
      stopp(a);
    }
    if (m) start(m, 'mus');
  }

  /* Etter scrolling: er musa fortsatt stille over en celle, start den på nytt. */
  function underMusa() {
    if (a || musX < 0 || !mqMus.matches || mqRo.matches || document.hidden) return;
    var el = document.elementFromPoint(musX, musY);
    if (el) pek({ target: el, clientX: musX, clientY: musY });
  }
  function planleggMus() {
    clearTimeout(roT);
    roT = setTimeout(underMusa, 180);
  }

  document.addEventListener('mouseover', pek);

  document.addEventListener('mousemove', function (e) {
    musX = e.clientX;
    musY = e.clientY;
    var n = Date.now();
    if (n - sist < 80) return;
    sist = n;
    pek(e);
  }, { passive: true });

  document.addEventListener('mouseout', function (e) {
    if (a && a.kind === 'mus' && !e.relatedTarget) stopp(a);
  });

  ['pointerenter', 'pointerleave'].forEach(function (navn) {
    document.addEventListener(navn, function (e) {
      var t = e.target;
      if (!(t instanceof Element) || !t.matches('product-card .card-gallery')) return;
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (!mqMus.matches || mqRo.matches) return;
      e.stopImmediatePropagation();
    }, true);
  });

  window.addEventListener('scroll', function (e) {
    if (touchModus()) {
      if (a && a.kind === 'touch') pause(a);
      clearTimeout(idleT);
      idleT = setTimeout(vurder, 260);
      return;
    }
    planleggMus();
    if (!a) return;
    var t = e.target;
    if (t instanceof Node && a.media.contains(t)) return;
    stopp(a);
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    tp = null;
    if (!touchModus() || e.touches.length !== 1) return;
    var t = e.touches[0];
    var m = mediaVed(t.clientX, t.clientY);
    if (m) tp = { x: t.clientX, y: t.clientY, m: m, n: Date.now() };
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var s0 = tp;
    tp = null;
    if (!s0 || !touchModus() || !e.changedTouches.length) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - s0.x;
    var dy = t.clientY - s0.y;
    if (Date.now() - s0.n > 700 || Math.abs(dx) < 36 || Math.abs(dx) < Math.abs(dy) * 1.6) return;
    sveip(s0.m, dx < 0 ? 1 : -1);
  }, { passive: true });

  document.addEventListener('touchcancel', function () { tp = null; }, { passive: true });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stopp(a);
    else setTimeout(vurder, 500);
  });
  window.addEventListener('blur', function () { if (a && a.kind === 'mus') stopp(a); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { stopp(a); ferdige = []; setTimeout(vurder, 600); }
  });
  window.addEventListener('resize', function () {
    clearTimeout(idleT);
    idleT = setTimeout(vurder, 400);
  });

  /* Nye celler («Last flere», filter): sjekk på nytt, men sjelden. */
  var skannT = 0;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      clearTimeout(skannT);
      skannT = setTimeout(skann, 500);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function oppstart() {
    setTimeout(vurder, 900);
    setTimeout(vurder, 3200);
    skann();
    setTimeout(skann, 2500);
  }
  if (document.readyState === 'complete') oppstart();
  else window.addEventListener('load', oppstart);
})();
